import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { ButtonHTMLAttributes } from "react";

type OutlinedButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: "black" | "white" | "gray" | "primary";
  bgColor?: "transparent" | "white" | "black";
  borderRadius?: "wide" | "wide-square";
  textCase?: "normal" | "uppercase" | "lowercase";
};

export function OutlinedButton({
  className,
  color = "white",
  bgColor = "transparent",
  children,
  type = "button",
  textCase = "uppercase",
  borderRadius = "wide",
  ...props
}: OutlinedButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        textVariants.button,
        "flex h-12 w-full items-center justify-center border bg-transparent px-4",
        "transition-all duration-200 ease-out hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-60",
        {
          "border-black hover:bg-black/10 active:bg-black/10": color === "black",
          "border-white text-white hover:bg-white/15 active:bg-white/15": color === "white",
          "border-gray-100 hover:bg-gray-100/10 active:bg-gray-100/10": color === "gray",
          "bg-white disabled:active:bg-white": bgColor === "white",
          "bg-black disabled:active:bg-black": bgColor === "black",
          "bg-screen-gs-1 disabled:active:bg-screen-gs-1": color === "primary",
          "bg-transparent disabled:active:bg-transparent": bgColor === "transparent",
          "!uppercase": textCase === "uppercase",
          "!lowercase": textCase === "lowercase",
          "!normal-case": textCase === "normal",
          "rounded-full": borderRadius === "wide",
          "rounded-[14px]": borderRadius === "wide-square",
        },
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
